import PlayerWalletActionType from './playerWalletActionType';

export const getPlayerWalletHistory = (params) => ({
  type: PlayerWalletActionType.GET_PLAYER_WALLET_HISTORY,
  payload: { params },
});

export const savePlayerWalletHistory = (data) => ({
  type: PlayerWalletActionType.SAVE_PLAYER_WALLET_HISTORY,
  payload: { data },
});

export const resetPlayerWalletHistory = () => ({
  type: PlayerWalletActionType.RESET_PLAYER_WALLET_HISTORY,
});

export const exportPlayerWalletHistory = (params) => ({
  type: PlayerWalletActionType.EXPORT_PLAYER_WALLET_HISTORY,
  payload: { params },
});

export const getPlayerWalletHistoryV2 = (params) => ({
  type: PlayerWalletActionType.GET_PLAYER_WALLET_HISTORY_V2,
  payload: { params },
});

export const savePlayerWalletHistoryV2 = (data) => ({
  type: PlayerWalletActionType.SAVE_PLAYER_WALLET_HISTORY_V2,
  payload: { data },
});

export const resetPlayerWalletHistoryV2 = () => ({
  type: PlayerWalletActionType.RESET_PLAYER_WALLET_HISTORY_V2,
});

export const exportPlayerWalletHistoryV2 = (params) => ({
  type: PlayerWalletActionType.EXPORT_PLAYER_WALLET_HISTORY_V2,
  payload: { params },
});

export const getPlayerWalletsInfo = (id, isLoading) => ({
  type: PlayerWalletActionType.GET_PLAYER_WALLETS_INFO,
  payload: { id, isLoading },
});

export const savePlayerWalletsInfo = (data) => ({
  type: PlayerWalletActionType.SAVE_PLAYER_WALLETS_INFO,
  payload: { data },
});

export const resetPlayerWalletsInfo = () => ({
  type: PlayerWalletActionType.RESET_PLAYER_WALLETS_INFO,
});

export const getPlayerWalletsInfoV2 = (id, isLoading) => ({
  type: PlayerWalletActionType.GET_PLAYER_WALLETS_INFO_V2,
  payload: { id, isLoading },
});

export const savePlayerWalletsInfoV2 = (data) => ({
  type: PlayerWalletActionType.SAVE_PLAYER_WALLETS_INFO_V2,
  payload: { data },
});

export const resetPlayerWalletsInfoV2 = () => ({
  type: PlayerWalletActionType.RESET_PLAYER_WALLETS_INFO_V2,
});

export const getPlayerExtraWallets = (id) => ({
  type: PlayerWalletActionType.GET_PLAYER_EXTRA_WALLETS,
  payload: { id },
});

export const savePlayerExtraWallets = (data) => ({
  type: PlayerWalletActionType.SAVE_PLAYER_EXTRA_WALLETS,
  payload: { data },
});

export const changePlayerExtraWalletsUpdatedStatus = (status) => ({
  type: PlayerWalletActionType.CHANGE_PLAYER_EXTRA_WALLETS_UPDATED_STATUS,
  payload: { status },
});

export const changePlayerWalletsInfoUpdatedStatus = (status) => ({
  type: PlayerWalletActionType.CHANGE_PLAYER_WALLETS_INFO_UPDATED_STATUS,
  payload: { status },
});

export const resetPlayerExtraWallets = () => ({
  type: PlayerWalletActionType.RESET_PLAYER_EXTRA_WALLETS,
});

export const changePlayerExtraWalletsLoading = (state) => ({
  type: PlayerWalletActionType.PLAYER_EXTRA_WALLETS_LOADING,
  payload: { state },
});

export const generatePlayersRealWalletsSumReport = (params) => ({
  type: PlayerWalletActionType.GENERATE_PLAYERS_REAL_WALLETS_SUM_REPORT,
  payload: { params },
});
